//@ts-nocheck

import React from 'react';
import moment from 'moment';

const DateFormatter = ({ date }) => {
    if (!date) {
        return null;
    }

    const normalizeDateFormat = (date) => {
        try {
            // Parse the date string and handle fractional seconds
            const parsedDate = date.split('.')[0];
            return parsedDate.endsWith('Z') ? parsedDate : parsedDate + 'Z';
        } catch (error) {
            return date;
        }
    };

    // Parse the date in UTC and convert to local time
    const formattedDate = moment.utc(normalizeDateFormat(date)).local();
    if (!formattedDate.isValid()) {
        return null;
    }

    return formattedDate.format('MMM DD, YYYY hh:mm A');
};

export default DateFormatter;